import Route, { getServerSideProps } from '../index';

export { getServerSideProps };
export default Route;
